var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
/**
 * # Badge
 *
 * 뱃지 컴포넌트입니다.
 *
 * @param {BadgeProps} {@link BadgeProps} 기본적인 프롭
 *
 * @example ```tsx
    <Badge type='primary' variant='contrast'>
      150
    </Badge>
    <Badge type='secondary' variant='contrast'>
      150
    </Badge>
    <Badge type='success' variant='contrast'>
      150
    </Badge>
    <Badge type='warning' variant='contrast'>
      150
    </Badge>
    <Badge type='error' variant='contrast'>
      150
    </Badge>
    <Badge type='violet' variant='contrast'>
      150
    </Badge>
 * ```
 */
export var Badge = function (props) {
    var _a = props.size, size = _a === void 0 ? 'normal' : _a, _b = props.type, type = _b === void 0 ? 'primary' : _b, _c = props.variant, variant = _c === void 0 ? 'primary' : _c, children = props.children, otherProps = __rest(props, ["size", "type", "variant", "children"]);
    return (<Container size={size} type={type} variant={variant} {...otherProps}>
      {children}
    </Container>);
};
var BadgeColorMapper = function (theme, params) { return ({
    primary: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.PRIMARY.FOREGROUND
                : theme.colors.PRIMARY.FOREGROUND,
        border: theme.colors.PRIMARY.FOREGROUND,
        color: params.outline ? theme.colors.PRIMARY.FOREGROUND : theme.colors.PRIMARY.BACKGROUND
    },
    secondary: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.PRIMARY.ACCENT_2
                : theme.colors.PRIMARY.ACCENT_5,
        border: theme.colors.PRIMARY.ACCENT_5,
        color: params.outline
            ? theme.colors.PRIMARY.FOREGROUND
            : params.variant === 'contrast'
                ? theme.colors.PRIMARY.ACCENT_7
                : theme.colors.PRIMARY.BACKGROUND
    },
    success: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.SUCCESS.LIGHTER
                : theme.colors.SUCCESS.DEFAULT,
        border: theme.colors.SUCCESS.DEFAULT,
        color: params.outline
            ? theme.colors.PRIMARY.FOREGROUND
            : params.variant === 'contrast'
                ? theme.colors.SUCCESS.DARK
                : theme.colors.PRIMARY.BACKGROUND
    },
    error: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.ERROR.LIGHTER
                : theme.colors.ERROR.DEFAULT,
        border: theme.colors.ERROR.DEFAULT,
        color: params.outline
            ? theme.colors.PRIMARY.FOREGROUND
            : params.variant === 'contrast'
                ? theme.colors.ERROR.DARK
                : theme.colors.PRIMARY.BACKGROUND
    },
    warning: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.WARNING.LIGHTER
                : theme.colors.WARNING.DEFAULT,
        border: theme.colors.WARNING.DEFAULT,
        color: params.outline
            ? theme.colors.PRIMARY.FOREGROUND
            : params.variant === 'contrast'
                ? theme.colors.WARNING.DARK
                : theme.colors.PRIMARY.BACKGROUND
    },
    violet: {
        background: params.outline
            ? theme.colors.PRIMARY.BACKGROUND
            : params.variant === 'contrast'
                ? theme.colors.VIOLET.LIGHTER
                : theme.colors.VIOLET.DEFAULT,
        border: theme.colors.VIOLET.DEFAULT,
        color: params.outline
            ? theme.colors.PRIMARY.FOREGROUND
            : params.variant === 'contrast'
                ? theme.colors.VIOLET.DARK
                : theme.colors.PRIMARY.BACKGROUND
    }
}); };
var Container = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 16px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: inherit;\n  font-feature-settings: tnum;\n  font-variant: tabular-nums;\n  text-transform: capitalize;\n  white-space: nowrap;\n  ", "\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 16px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: inherit;\n  font-feature-settings: tnum;\n  font-variant: tabular-nums;\n  text-transform: capitalize;\n  white-space: nowrap;\n  ", "\n"])), function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n    \n    ", "\n  "], ["\n    background: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n    \n    ", "\n  "])), BadgeColorMapper(theme, props)[props.type].background, BadgeColorMapper(theme, props)[props.type].color, BadgeColorMapper(theme, props)[props.type].border, props.size === 'small' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 3px 7px;\n      font-size: 0.625rem;\n    "], ["\n      padding: 3px 7px;\n      font-size: 0.625rem;\n    "]))), props.size === 'normal' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: 2px 7px;\n      font-size: 0.875rem;\n    "], ["\n      padding: 2px 7px;\n      font-size: 0.875rem;\n    "]))), props.size === 'large' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: 3px 10px;\n      font-size: 1rem;\n    "], ["\n      padding: 3px 10px;\n      font-size: 1rem;\n    "]))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.jsx.map